import { render, staticRenderFns } from "./Four.vue?vue&type=template&id=ddee0aba"
import script from "./Four.vue?vue&type=script&lang=js"
export * from "./Four.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports